import {
  checkFormValidOnInputChange,
  enableOrDisableSubmitButton,
} from "../utils/validation/enableOrDisableSubmitButton";
import { buyValidationOptions } from "../utils/validation/buyValidationOptions";

const $dobInputDay = $("#dob-day");
const $dobInputMonth = $("#dob-month");
const $dobInputYear = $("#dob-year");
const $dobHiddenInput = $("#dobHidden");
const $dobForm = $dobHiddenInput.closest("form");

function updateDobHiddenField(day, month, year) {
  if (
    // If we have the requisite length of each field, update the hidden field
    $dobInputDay.val() !== "" &&
    $dobInputDay.val().length === 2 &&
    $dobInputMonth.val() !== "" &&
    $dobInputMonth.val().length === 2 &&
    $dobInputYear.val() !== "" &&
    $dobInputYear.val().length === 4
  ) {
    let date = new Date(year + "-" + month + "-" + day);
    if (date.toJSON() !== null) {
      $dobHiddenInput.val(date.toJSON().slice(0, 10));
      $dobForm.valid(); // Force revalidation - needed to add or clear error message on hidden input
    }
  } else {
    // Clear out input - otherwise it would remain valid
    $dobHiddenInput.val("");
    $dobForm.valid(); // Force revalidation - needed to add or clear error message on hidden input
  }
  enableOrDisableSubmitButton($dobForm);
}

function tabToNextInput(currentInput, nextInput) {
  if (
    currentInput.val().length === parseInt(currentInput.attr("maxlength")) &&
    currentInput.val() <= currentInput.attr("max") &&
    parseInt(currentInput.val()) >= parseInt(currentInput.attr("min"))
  ) {
    if (nextInput.length)
      // If there is a input following
      nextInput.focus().select();
    // Focus the next element and select the text, so that you can overwrite it
    else currentInput.blur();
  }
}

if ($dobForm.length > 0) {
  $dobForm.validate(buyValidationOptions);
  // Listen for change, etc on input
  checkFormValidOnInputChange($dobForm);
  // Page load
  $(document).ready(function () {
    enableOrDisableSubmitButton($dobForm);
  });

  $(document).on("input", "input", function (e) {
    const $target = $(e.target);
    tabToNextInput($target, $target.parents(".field").next().find("input"));
    updateDobHiddenField(
      $dobInputDay.val(),
      $dobInputMonth.val(),
      $dobInputYear.val()
    );
  });
}
